import { mix } from "@chorda/core";
export const Box = (props) => {
    return mix({
        css: 'box',
    }, props && {
        css: props.css,
        styles: props.styles,
        templates: {
            content: props.content
        },
        text: props.text,
        html: props.html,
        items: props.items
    });
};
